import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Plugs.es.js";
const e = o.forwardRef((r, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...r, weights: a }));
e.displayName = "PlugsIcon";
const n = e;
export {
  n as Plugs,
  e as PlugsIcon
};
